import _defineProperty from "@babel/runtime/helpers/defineProperty";import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";import _classCallCheck from "@babel/runtime/helpers/classCallCheck";import _createClass from "@babel/runtime/helpers/createClass";import _regeneratorRuntime from "@babel/runtime/regenerator";function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}import isPlainObject from 'lodash/isPlainObject';


var baseURL = 'https://cdn.contentful.com';

/**
 * The Contentful npm package had a sub dependency which had a sub dependency that had
 * code that was not transpiled (not intended for client side use), which ended up breaking
 * in Internet Explorer.
 * We had a few solutions at our disposal, but ended up with creating a wrapper around the contentful
 * RESTful API.
 * See [TM-79](https://navegate.atlassian.net/browse/TM-79) for more information.
 *
 * Documentation of the API:
 * @link https://www.contentful.com/developers/docs/references/content-delivery-api/
 */
export var Contentful = /*#__PURE__*/function () {



  function Contentful(spaceID, accessToken) {_classCallCheck(this, Contentful);
    this.spaceID = spaceID;
    this.accessToken = accessToken;
  }_createClass(Contentful, [{ key: "fetch", value: function (_fetch) {function fetch(_x) {return _fetch.apply(this, arguments);}fetch.toString = function () {return _fetch.toString();};return fetch;}( /*#__PURE__*/function () {var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(

        function _callee(url) {var options,response,errorMessage,_args = arguments;return _regeneratorRuntime.wrap(function _callee$(_context) {while (1) switch (_context.prev = _context.next) {case 0:options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};_context.prev = 1;_context.next = 4;return (

                  fetch(url, _objectSpread(_objectSpread({},
                  options), {}, {
                    headers: {
                      Authorization: "Bearer ".concat(this.accessToken)
                    } })
                  ));case 4:response = _context.sent;_context.next = 7;return (

                  response.json());case 7:return _context.abrupt("return", _context.sent);case 10:_context.prev = 10;_context.t0 = _context["catch"](1);

                errorMessage = 'Contentful fetch failed';
                if (_context.t0 instanceof Error) {
                  errorMessage = _context.t0.message;
                }return _context.abrupt("return",
                new Promise(function (_, rej) {return rej(errorMessage);}));case 15:case "end":return _context.stop();}}, _callee, this, [[1, 10]]);}));return function (_x2) {return _ref.apply(this, arguments);};}()) }, { key: "generateURL", value:



    function generateURL(queryType, params) {var environment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'master';
      var url = "".concat(baseURL, "/spaces/").concat(this.spaceID, "/environments/").concat(environment, "/").concat(queryType);

      if (params) {
        var searchParams = new URLSearchParams(params);
        url += "?".concat(searchParams.toString());
      }

      return url;
    } }, { key: "getEntry", value: function () {var _getEntry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(

        function _callee2(entryID) {var url;return _regeneratorRuntime.wrap(function _callee2$(_context2) {while (1) switch (_context2.prev = _context2.next) {case 0:
                url = this.generateURL('entries') + "/".concat(entryID);_context2.next = 3;return (
                  this.fetch(url));case 3:return _context2.abrupt("return", _context2.sent);case 4:case "end":return _context2.stop();}}, _callee2, this);}));function getEntry(_x3) {return _getEntry.apply(this, arguments);}return getEntry;}() }, { key: "getAsset", value: function () {var _getAsset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(


        function _callee3(assetID) {var url;return _regeneratorRuntime.wrap(function _callee3$(_context3) {while (1) switch (_context3.prev = _context3.next) {case 0:
                url = this.generateURL('assets') + "/".concat(assetID);_context3.next = 3;return (
                  this.fetch(url));case 3:return _context3.abrupt("return", _context3.sent);case 4:case "end":return _context3.stop();}}, _callee3, this);}));function getAsset(_x4) {return _getAsset.apply(this, arguments);}return getAsset;}() }, { key: "getEntries", value: function () {var _getEntries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(


        function _callee4(query) {var url;return _regeneratorRuntime.wrap(function _callee4$(_context4) {while (1) switch (_context4.prev = _context4.next) {case 0:
                if (!isPlainObject(query)) {
                  console.error("Contentful: Provided params (".concat(query, ") is not an object"));
                }

                url = this.generateURL('entries', query);_context4.next = 4;return (

                  this.fetch(url));case 4:return _context4.abrupt("return", _context4.sent);case 5:case "end":return _context4.stop();}}, _callee4, this);}));function getEntries(_x5) {return _getEntries.apply(this, arguments);}return getEntries;}() }]);return Contentful;}();
//# sourceMappingURL=Contentful.js.map